import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchTemplateForEditor, fetchTemplateOnly, saveTemplate, updateMatchLayout } from './actions';
import { ManagerSliceState } from './manager.slice';

export const createFetchTemplateForEditorReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(fetchTemplateForEditor.pending, (state) => {
    state.isLoading = true;
    state.isLoaded = false;
    state.error = null;
  });
  builder.addCase(fetchTemplateForEditor.fulfilled, (state, action) => {
    state.activeTemplate = action.payload as any;
    state.isLoading = false;
    state.isLoaded = true;
  });
  builder.addCase(fetchTemplateForEditor.rejected, (state, action) => {
    state.isLoading = false;
    state.isLoaded = false;
    state.error = action.error.message ?? 'Failed to load template';
  });
};

export const createFetchTemplateOnlyReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(fetchTemplateOnly.pending, (state) => {
    state.isLoading = true;
    state.isLoaded = false;
    state.error = null;
  });
  builder.addCase(fetchTemplateOnly.fulfilled, (state, action) => {
    state.activeTemplate = action.payload as any;
    state.isLoading = false;
    state.isLoaded = true;
  });
  builder.addCase(fetchTemplateOnly.rejected, (state, action) => {
    state.isLoading = false;
    state.isLoaded = false;
    state.error = action.error.message ?? 'Failed to load template';
  });
};

export const createSaveTemplateReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(saveTemplate.pending, (state) => {
    state.isSaving = true;
    state.error = null;
  });
  builder.addCase(saveTemplate.fulfilled, (state, action) => {
    state.isSaving = false;
    state.activeTemplate = action.payload as any;
  });
  builder.addCase(saveTemplate.rejected, (state, action) => {
    state.isSaving = false;
    state.error = action.error.message ?? 'Failed to save template';
  });
};

export const createUpdateMatchLayoutReducer = (builder: ActionReducerMapBuilder<ManagerSliceState>) => {
  builder.addCase(updateMatchLayout.pending, (state) => {
    state.isSaving = true;
    state.error = null;
  });
  builder.addCase(updateMatchLayout.fulfilled, (state, action) => {
    state.isSaving = false;
    state.activeTemplate = action.payload as any;
  });
  builder.addCase(updateMatchLayout.rejected, (state, action) => {
    state.isSaving = false;
    state.error = action.error.message ?? 'Failed to save match layout';
  });
};

